import ProductApiService from "../apiServices/ProductApiService";
import { ProductDetailsModal } from "../../interfaces/ProductObject";

/**
 * Resolves full product details for a set of productIds.
 *
 * Exists because ProductApiService.getProductsByIds is typed as returning
 * ProductDetailsModal[] directly, and that is WRONG — it does a bare
 * `return response.json()` without shaping anything, so the real payload is
 * the NineBusinessRs envelope. Every caller (CartThunk, ProductListThunks,
 * ProductDetailsThunks, CategoryShowcase, both dine-in thunks) has to reach
 * through `contents[0].products` itself, each repeating the same explanation
 * of why the declared type can't be trusted.
 *
 * This is that unwrap, written once. Callers get the array the original
 * signature promised. Fix the service's return type one day and this becomes a
 * thin passthrough rather than something to delete in a hurry.
 */
export async function fetchProductsByIds(
  productIds: string[]
): Promise<ProductDetailsModal[]> {
  if (productIds.length === 0) return [];
  const response: any = await ProductApiService.getProductsByIds(productIds);
  return response?.contents?.[0]?.products ?? [];
}

export default { fetchProductsByIds };
